import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP new-users source (`GET /analytics/new-users-rpp`): players who registered
 * for the program in the period, from our own data.
 *
 * Its own source rather than the RPP half of a `new-users` split card, because
 * the two never had the whole-and-part relationship a split implies: an app
 * account created and an RPP registration filed are different events on
 * different tables, so a player registering for RPP with an older app account is
 * new here and not there. Read the two side by side, never summed.
 *
 * Province filtering is exact here (the RPP registration record's province).
 * Total-only: the endpoint declares `capabilities.daily=false`, so no `line`
 * form.
 */
export const newUsersRppSource = createEnvelopeSource({
    label: 'RPP new users',
    endpoint: 'analytics/new-users-rpp',
    metrics: [{ id: 'newUsersRpp', label: 'RPP new users', type: 'scalar' }],
    forms: ['number'],
    regionGrain: 'province',
});
